<template>
    <div class="bg">
        <div id="main" class="container">
            <Loader v-if="isLoading" />
            <AlertContainer :messages="msgs" />
            <div class="listing-header mb-3">
                <div class="title-breadcrumb">
                    <h1 class="title">
                        {{ $t('vincular-colaborador') }}
                    </h1>
                </div>
                <div class="header-buttons">
                    <button
                        class="delete-btn"
                        type="button"
                        @click="onFecharModal"    
                    >
                        {{ $t("cancelar") }}
                    </button>
                    <button
                        class="save-btn"
                        type="button"
                        @click="salvar"
                        :disabled="colaboradoresSelecionados.length === 0 && !isEdit">
                        {{ $t("salvar") }}
                    </button>
                </div>
            </div>
            <div class="form-columns-fit">
                <div class="columns is-flex-wrap">
                    <div class="column is-6">
                        <vss-select
                            :title="'empresa'"
                            :options="empresaSelect"
                            v-model="empresaSelected"
                            @input="updateEmpresa"
                        />
                    </div>
                </div>
            <div class="search-and-filter" v-if="!isEdit">
                <div class="search-bar">
                    <search-bar
                        :onSearch="debouncedOnSearch"
                    />
                </div>
            </div>

            <div class="registry-wrapper" v-if="!isEdit">
                <empty-table-message v-if="isEmpty" />
                <b-table
                    v-else
                    :data="colaboradores"
                    class="data-table"
                    @sort="sortTable"
                    backend-sorting
                    checkable
                    :checked-rows.sync="colaboradoresSelecionados"
                    :custom-is-checked="(selecionados, linha) => selecionados.idusuario === linha.idusuario">
                    <b-table-column
                        v-for="(f, i) in fields"
                        :key="i"
                        :field="f.key"
                        :label="$t(f.key)"
                        :width="f.width"
                        :sortable="f.sortable"
                        :custom-sort="f.sortFn"
                        v-slot="props"
                        >
                        <span>{{ props.row[f.key] }}</span>
                    </b-table-column>
                </b-table>
                <PaginationViewer
                    class="mb-0"
                    :resetPagination="pagination.resetPagination"
                    :totalItems="pagination.totalRows"
                    :perPageOptions="pagination.perPageOptions"
                    :optionStarted="pagination.optionStarted"
                    @change="updatePagination"
                />
            </div>
        </div>
        </div>
    </div>
</template>

<script>
// SERVICES
import ColaboradorService from "@/services/ColaboradorService";
import EmpresaService from "@/services/vendas/empresa/EmpresaService";
import AssTurnoColaboradorService from '@/services/AssTurnoColaboradorService';

// COMPONENTS
import Loader from "@/components/content/loader/Loader";
import AlertContainer from "@/components/shared/AlertContainer";

// MENSAGENS
import Message from "@/models/Message";

export default {
    components: {
        Loader,
        AlertContainer
    },
    props: {
        idTurno: 0,
        selected: {
            type: Object,
            default: () => {}
        },
    },
    data() {
        return {
            service: new ColaboradorService(this.$http, this.$router),
            empresaService: new EmpresaService(this.$http, this.$router),
            assTurnoColaboradorservice: new AssTurnoColaboradorService(this.$http, this.$router),
            colaboradores: [],
            isLoading: false,
            isEmpty: false,
            isEdit: false,
            assturnocolaborador: {},
            fields: [
                {key: 'nome', width: null, sortable: true, sortFn: null},
            ],
            colaboradoresSelecionados: [],
            idturno: 0,
            debouncedOnSearch: null,
            queryFilter: '',
            pagination: {
                resetPagination: false,
                perPageOptions: [10, 25, 50, 100, 400],
                optionStarted: 0,
                perPage: null,
                totalRows: 0,   
                currentPage: 1,
            },
            empresaSelect: [],
            empresaSelected: null,
            column: 'descricao',
            order: 'asc',
            msgs: [],
        }
    },
    created() {
        this.pagination.perPage = this.pagination.perPageOptions[this.pagination.optionStarted];
        this.debouncedOnSearch = this.debounce(this.onSearch, 500);

        this.carregarDados();
    },
    methods: {
        carregarDados(){
            this.loadEmpresa();
        },
        carregarColaboradores(currentPage = 1) {
            if(!this.empresaSelected || !this.empresaSelected.id){
                return;
            }
            
            if (currentPage == 1 && this.pagination.currentPage != 1){
                this.pagination.resetPagination = true;
            }
            
            this.isLoading = true;
            this.service
            .findAllNaoAssociadosTurnoByEmpresa(
                    this.$route.params.id,
                    this.empresaSelected.id,
                    this.column,
                    this.order,
                    currentPage - 1,
                    this.pagination.perPage,
                    this.queryFilter,
                )
            .then(this.mapItems)
            .then(value => {
                this.colaboradores = value;
                this.isEmpty = this.colaboradores.length === 0;
            })
            .catch(e => {
                this.isEmpty = true;
                this.$root.showMessage('error', 'msg-erro-load');
                console.error('Erro ao carregar os dados.');
            })
            .finally(_ => {
                this.isLoading = false;
                this.pagination.resetPagination = false;
            });
        },

        generateId(numberId){
            return this.$route.name+'-turno-'+numberId;
        },
        multiplicadorUpdate(value){
            this.multiplicadorweb = value;
        },
        multiplicadortrocaUpdate(value){
            this.multiplicadortrocaweb = value;
        },
        mapItemsEmpresa(body) {
            return body.content.map(m => {
                return {
                    id: m.id,
                    label: m.nome
                };
            });
        },
        mapItems(body) {
            this.pagination.totalRows = body.totalElements;

            return body.content.map(m => {
                return {
                    idusuario: m.idusuario,
                    nome: m.nome,
                };
            });
        },
        loadEmpresa() {
            this.empresaService
            .findAllComboSituacao(
                    this.queryFilter,
            )
            .then(this.mapItemsEmpresa)
            .then(value => {
                this.empresaSelect = value;
                this.empresaSelected = this.empresaSelect[0]
            })
            .catch(e => {
                this.isEmpty = true;
                this.$root.showMessage('error', 'msg-erro-load');
                console.error('Erro ao carregar os dados.');
            })
            .finally(_ => {
                this.carregarColaboradores();
            });
        },
        mapColaboradorTurno(item) {
            this.assturnocolaborador.idassturnocolaborador = item.idassturnocolaborador
            this.assturnocolaborador.idcolaborador = item.idcolaborador
            this.assturnocolaborador.nome = item.nome
            this.trabalhaColaboradorSelected.id = this.trabalhaColaboradorSelect[item.trabalhacolaborador]
        },
        mapOnSave(itens) {
            return itens.map(m => {
                return {
                    idturno: this.$route.params.id,
                    idempresa: this.empresaSelected.id,
                    idusuario: m.idusuario
                };
            });
        },
        sortTable(field, order) {
            this.column = field;
            this.order = order;
            this.carregarColaboradores(this.pagination.currentPage);
        },
        onSearch(value) {
            this.queryFilter = this.removeAcentos(value);
            this.pagination.currentPage = 1;
            this.carregarColaboradores();
        },
        updatePagination(value) {
            this.pagination.resetPagination = false;
            this.pagination.perPage = value.perPage;
            this.pagination.currentPage = value.currentPage;
            this.carregarColaboradores(value.currentPage);
        },
        salvar() {
            if (this.colaboradoresSelecionados.length > 0 || this.isEdit) {
                this.isLoading = true;

                const listasDivididas = this.dividirLista(this.colaboradoresSelecionados, 5);
                const promises = listasDivididas.map(lista => {
                    return this.assTurnoColaboradorservice.saveBulk(this.mapOnSave(lista))
                })

                Promise.allSettled(promises)
                    .then(value => {
                        if (value.content === null) {
                            this.msgs.push(new Message("error", `${value.message}`, true));
                        } else {
                            this.onFecharModal()
                            this.$root.showMessage('success', 'msg-sucesso-ao-adicionar-associacao');
                        }
                    })
                    .catch((e) => {
                        this.msgs.push(new Message("alert", 'msg-erro-load', true));
                    })
                    .finally(() => {
                        this.isLoading = false;
                    });
            }
        },

        dividirLista(lista, tamanhoMaximo) {
            const sublistas = [];
            for (let i = 0; i < lista.length; i += tamanhoMaximo) {
                sublistas.push(lista.slice(i, i + tamanhoMaximo));
            }
            return sublistas;
        },
        onFecharModal(){
            this.isEdit = false
            this.$emit('fecharModal',true);
        },
        updateEmpresa(empresa){
            this.empresaSelected = empresa
            this.carregarColaboradores();
        }
    },
}
</script>


<style lang="scss" scoped>
.container {
    min-height: 200px;
}
#main {
    padding: 20px 20px;

    .search-and-filter {
        .search-bar {
            width: 100%;
        }
        @media (max-width: 1060px) {
            .search-bar {
                padding-right: 0;
            }
        }
    }
}

</style>